export default __webpack_public_path__ + "static/media/Group 2166@2x.7b1500ab.png";